var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',{staticClass:"propertyValue",attrs:{"width":60,"disabled":!_vm.isEditable},on:{"change":_vm.saveChange},model:{value:(_vm.textValue),callback:function ($$v) {_vm.textValue=$$v},expression:"textValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }